import { createContext, useContext } from "react";

export const BootstrapContext = createContext(null);

export function useBootstrapContext() {
  const context = useContext(BootstrapContext);

  if (!context) {
    throw new Error(
      "useBootstrapContext must be used inside BootstrapProvider",
    );
  }

  return context;
}
